// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";
import { TypeFilterObject } from "@hex-insights/core";
import {
	ContractSelectField,
	CourseAssessmentMarkSelectField,
	CourseAssessmentSubmissionSelectField,
	CourseAttendanceRecordSelectField,
	EnrollmentApplicationStudentSelectField,
	MessageTopicSelectField,
	PersonSelectField,
	RelationshipSelectField,
	ReportCardSelectField,
	SchoolAttendanceRecordSelectField,
	StudentAcademicTermEnrollmentSelectField,
	StudentCourseSectionEnrollmentSelectField,
	StudentDataConsentSelectField,
	StudentEnrollmentIntentSelectField,
	StudentHomeRoomSectionEnrollmentSelectField,
	StudentInformationVerificationSelectField,
	StudentMedicalConditionSelectField,
	StudentMedicalContactSelectField,
	StudentMedicalEventSelectField,
	StudentMedicalProfileSelectField,
	StudentNoteSelectField,
	StudentOTCMedicationSelectField,
	StudentPrescriptionMedicationSelectField,
	StudentVaccinationRecordSelectField,
} from "../../Forms";
import { registry } from "../registry";
import * as CustomFilterFormValues from "./form-values-custom";

export type FilterFormValues = CustomFilterFormValues.StandardFilterFormValues &
	IndexForms.SearchFormValues &
	IndexForms.FilterFormValues;

export const initial: FilterFormValues = {
	...CustomFilterFormValues.initialStandardFilters,
	...IndexForms.initialSearchFormValues,
	...IndexForms.initialFilterFormValues,
};

export function getInitial(initialFormValues?: Partial<FilterFormValues>): FilterFormValues {
	return { ...initial, ...initialFormValues };
}

export const typeFilterObject: TypeFilterObject<FilterFormValues> = {
	...CustomFilterFormValues.standardFiltersTypeFilterObject,
	...IndexForms.searchFormValuesFilterObject,
	...IndexForms.filterFormValuesFilterObject,
};

export const advancedFilterInformation: IndexForms.AdvancedFilterInformation = {
	fieldOptions: [
		{ value: "graduationYear" },
		{ value: "contracts" },
		{ value: "courseAssessmentMarks" },
		{ value: "courseAssessmentSubmissions" },
		{ value: "courseAttendanceRecords" },
		{ value: "enrollmentApplicationStudents" },
		{ value: "messageTopics" },
		{ value: "person" },
		{ value: "primaryStudentNotes" },
		{ value: "relationships" },
		{ value: "reportCards" },
		{ value: "schoolAttendanceRecords" },
		{ value: "secondaryStudentNotes" },
		{ value: "studentAcademicTermEnrollments" },
		{ value: "studentCourseSectionEnrollments" },
		{ value: "studentDataConsents" },
		{ value: "studentEnrollmentIntents" },
		{ value: "studentHomeRoomSectionEnrollments" },
		{ value: "studentInformationVerifications" },
		{ value: "studentMedicalConditions" },
		{ value: "studentMedicalContacts" },
		{ value: "studentMedicalEvents" },
		{ value: "studentMedicalProfile" },
		{ value: "studentOtcMedications" },
		{ value: "studentPrescriptionMedications" },
		{ value: "studentVaccinationRecords" },
	],
	fieldComparisonOptions: {
		graduationYear: [...IndexForms.numberComparisonOptions, ...IndexForms.nullableComparisonOptions],
		contracts: IndexForms.multipleEdgeComparisonOptions,
		courseAssessmentMarks: IndexForms.multipleEdgeComparisonOptions,
		courseAssessmentSubmissions: IndexForms.multipleEdgeComparisonOptions,
		courseAttendanceRecords: IndexForms.multipleEdgeComparisonOptions,
		enrollmentApplicationStudents: IndexForms.multipleEdgeComparisonOptions,
		messageTopics: IndexForms.multipleEdgeComparisonOptions,
		person: IndexForms.singularEdgeComparisonOptions,
		primaryStudentNotes: IndexForms.multipleEdgeComparisonOptions,
		relationships: IndexForms.multipleEdgeComparisonOptions,
		reportCards: IndexForms.multipleEdgeComparisonOptions,
		schoolAttendanceRecords: IndexForms.multipleEdgeComparisonOptions,
		secondaryStudentNotes: IndexForms.multipleEdgeComparisonOptions,
		studentAcademicTermEnrollments: IndexForms.multipleEdgeComparisonOptions,
		studentCourseSectionEnrollments: IndexForms.multipleEdgeComparisonOptions,
		studentDataConsents: IndexForms.multipleEdgeComparisonOptions,
		studentEnrollmentIntents: IndexForms.multipleEdgeComparisonOptions,
		studentHomeRoomSectionEnrollments: IndexForms.multipleEdgeComparisonOptions,
		studentInformationVerifications: IndexForms.multipleEdgeComparisonOptions,
		studentMedicalConditions: IndexForms.multipleEdgeComparisonOptions,
		studentMedicalContacts: IndexForms.multipleEdgeComparisonOptions,
		studentMedicalEvents: IndexForms.multipleEdgeComparisonOptions,
		studentMedicalProfile: [
			...IndexForms.singularEdgeComparisonOptions,
			...IndexForms.nullableSingularEdgeComparisonOptions,
		],
		studentOtcMedications: IndexForms.multipleEdgeComparisonOptions,
		studentPrescriptionMedications: IndexForms.multipleEdgeComparisonOptions,
		studentVaccinationRecords: IndexForms.multipleEdgeComparisonOptions,
	},
	fieldComparisonTranslations: {
		graduationYear: { ...IndexForms.numberComparisonTranslations, ...IndexForms.nullableComparisonTranslations },
		contracts: IndexForms.getMultipleEdgeComparisonTranslations(
			ContractSelectField.Select,
			ContractSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		courseAssessmentMarks: IndexForms.getMultipleEdgeComparisonTranslations(
			CourseAssessmentMarkSelectField.Select,
			CourseAssessmentMarkSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		courseAssessmentSubmissions: IndexForms.getMultipleEdgeComparisonTranslations(
			CourseAssessmentSubmissionSelectField.Select,
			CourseAssessmentSubmissionSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		courseAttendanceRecords: IndexForms.getMultipleEdgeComparisonTranslations(
			CourseAttendanceRecordSelectField.Select,
			CourseAttendanceRecordSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		enrollmentApplicationStudents: IndexForms.getMultipleEdgeComparisonTranslations(
			EnrollmentApplicationStudentSelectField.Select,
			EnrollmentApplicationStudentSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		messageTopics: IndexForms.getMultipleEdgeComparisonTranslations(
			MessageTopicSelectField.Select,
			MessageTopicSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		person: IndexForms.getSingularEdgeComparisonTranslations(
			PersonSelectField.Select,
			PersonSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		primaryStudentNotes: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentNoteSelectField.Select,
			StudentNoteSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		relationships: IndexForms.getMultipleEdgeComparisonTranslations(
			RelationshipSelectField.Select,
			RelationshipSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		reportCards: IndexForms.getMultipleEdgeComparisonTranslations(
			ReportCardSelectField.Select,
			ReportCardSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		schoolAttendanceRecords: IndexForms.getMultipleEdgeComparisonTranslations(
			SchoolAttendanceRecordSelectField.Select,
			SchoolAttendanceRecordSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		secondaryStudentNotes: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentNoteSelectField.Select,
			StudentNoteSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		studentAcademicTermEnrollments: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentAcademicTermEnrollmentSelectField.Select,
			StudentAcademicTermEnrollmentSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		studentCourseSectionEnrollments: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentCourseSectionEnrollmentSelectField.Select,
			StudentCourseSectionEnrollmentSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		studentDataConsents: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentDataConsentSelectField.Select,
			StudentDataConsentSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		studentEnrollmentIntents: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentEnrollmentIntentSelectField.Select,
			StudentEnrollmentIntentSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		studentHomeRoomSectionEnrollments: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentHomeRoomSectionEnrollmentSelectField.Select,
			StudentHomeRoomSectionEnrollmentSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		studentInformationVerifications: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentInformationVerificationSelectField.Select,
			StudentInformationVerificationSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		studentMedicalConditions: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentMedicalConditionSelectField.Select,
			StudentMedicalConditionSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		studentMedicalContacts: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentMedicalContactSelectField.Select,
			StudentMedicalContactSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		studentMedicalEvents: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentMedicalEventSelectField.Select,
			StudentMedicalEventSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		studentMedicalProfile: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				StudentMedicalProfileSelectField.Select,
				StudentMedicalProfileSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		studentOtcMedications: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentOTCMedicationSelectField.Select,
			StudentOTCMedicationSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		studentPrescriptionMedications: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentPrescriptionMedicationSelectField.Select,
			StudentPrescriptionMedicationSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		studentVaccinationRecords: IndexForms.getMultipleEdgeComparisonTranslations(
			StudentVaccinationRecordSelectField.Select,
			StudentVaccinationRecordSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
	},
};

registry.register("Student", advancedFilterInformation, {
	contracts: "Contract",
	courseAssessmentMarks: "CourseAssessmentMark",
	courseAssessmentSubmissions: "CourseAssessmentSubmission",
	courseAttendanceRecords: "CourseAttendanceRecord",
	enrollmentApplicationStudents: "EnrollmentApplicationStudent",
	messageTopics: "MessageTopic",
	person: "Person",
	primaryStudentNotes: "StudentNote",
	relationships: "Relationship",
	reportCards: "ReportCard",
	schoolAttendanceRecords: "SchoolAttendanceRecord",
	secondaryStudentNotes: "StudentNote",
	studentAcademicTermEnrollments: "StudentAcademicTermEnrollment",
	studentCourseSectionEnrollments: "StudentCourseSectionEnrollment",
	studentDataConsents: "StudentDataConsent",
	studentEnrollmentIntents: "StudentEnrollmentIntent",
	studentHomeRoomSectionEnrollments: "StudentHomeRoomSectionEnrollment",
	studentInformationVerifications: "StudentInformationVerification",
	studentMedicalConditions: "StudentMedicalCondition",
	studentMedicalContacts: "StudentMedicalContact",
	studentMedicalEvents: "StudentMedicalEvent",
	studentMedicalProfile: "StudentMedicalProfile",
	studentOtcMedications: "StudentOTCMedication",
	studentPrescriptionMedications: "StudentPrescriptionMedication",
	studentVaccinationRecords: "StudentVaccinationRecord",
});
